import { render } from "./page12.vue?vue&type=template&id=567b0c22&scoped=true"
import script from "./page12.vue?vue&type=script&lang=js"
export * from "./page12.vue?vue&type=script&lang=js"

import "./page12.vue?vue&type=style&index=0&id=567b0c22&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567b0c22"]])

export default __exports__